"use strict";
exports.__esModule = true;
exports.Execution = void 0;
// (C) 2007-2018 GoodData Corporation
var Execution;
(function (Execution) {
    function isAttributeHeaderItem(header) {
        return header.attributeHeaderItem !== undefined;
    }
    Execution.isAttributeHeaderItem = isAttributeHeaderItem;
    function isMeasureHeaderItem(header) {
        return header.measureHeaderItem !== undefined;
    }
    Execution.isMeasureHeaderItem = isMeasureHeaderItem;
    function isTotalHeaderItem(header) {
        return header.totalHeaderItem !== undefined;
    }
    Execution.isTotalHeaderItem = isTotalHeaderItem;
    function isAttributeHeader(header) {
        return header.attributeHeader !== undefined;
    }
    Execution.isAttributeHeader = isAttributeHeader;
    function isMeasureGroupHeader(header) {
        return header.measureGroupHeader !== undefined;
    }
    Execution.isMeasureGroupHeader = isMeasureGroupHeader;
})(Execution = exports.Execution || (exports.Execution = {}));
//# sourceMappingURL=Execution.js.map